<template lang="html">
  <div class="mx-auto gMapContainer">
    <label>
      Dirección
      <sup class="required-tip">*</sup>
    </label>
    <gmap-autocomplete
      onclick="this.select()"
      ref="gMapAddress"
      id="gMapAddress"
      @focus="handleFocus"
      @blur="$emit('blur')"
      @place_changed="setGeopointAddress"
      @change="$emit('addressChanged', $event.target.value)"
      :disabled="!newCity && !publicationGeopoint"
      :componentRestrictions="{ country: ['ar'] }"
      :types="['address']"
      :options="{ fields: ['geometry', 'formatted_address'] }"
      type="text"
      placeholder="Ingresá la dirección"
      class="form-control"
      :value="publicationGeopoint && publicationGeopoint.string ? publicationGeopoint.string : ''">
    </gmap-autocomplete>
    <label class="mt-2 text-secondary">
      De ser necesario, ajustá la ubicación del pin
    </label>
    <GmapMap :center="gMapCenter"
             :zoom="14"
             :options="{
               zoomControl: true,
               mapTypeControl: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: false
             }"
             map-type-id="roadmap"
             ref="gMapAddressMarker"
             id="gMapAddressMarker"
             style="width: 100%; height: 300px;">
      <GmapMarker :position="gMapMarker"
                  :clickable="true"
                  :draggable="true"
                  @dragend="pinToAddress"
                  @click="center=gMapCenter"/>
    </GmapMap>
  </div>
</template>

<script>
import store from '@/store'
import { trunkFloat } from '@/helpers'

export default {
  props: {
    newCity: String
  },

  data: () => ({

  }),

  mounted () {
    if(this.publicationGeopoint && this.publicationGeopoint.string) {
      this.$emit('addressChanged', this.publicationGeopoint.string);
    }
  },

  computed: {
    publicationGeopoint: () => store.state.sell.geopoint,

    categoryBreadcrumbs: () => store.state.sell.category_path,

    parentCategoryId () { return this.categoryBreadcrumbs[0] && this.categoryBreadcrumbs[0].id },

    isFetching: () => store.state.sell.isFetching,

    searchLocation: () => store.state.location,

    gMapCenter () {
      const geo = this.publicationGeopoint
      return geo && geo.lat && geo.lon ?
        { lat: parseFloat(geo.lat), lng: parseFloat(geo.lon) } :
        { lat: parseFloat(this.searchLocation.lat), lng: parseFloat(this.searchLocation.lon) }
    },

    gMapMarker () {
      const geo = this.publicationGeopoint
      return geo && geo.lat && geo.lon ? { lat: parseFloat(geo.lat), lng: parseFloat(geo.lon) } : null
    }
  },

  methods: {
    setGeopointAddress (geopoint) {
      if (Object.entries(geopoint).length <= 1) return

      store.dispatch('sell/setIsFetching', true)
      let address = {
        city: this.newCity || this.publicationGeopoint.city,
        string: geopoint.formatted_address,
        lat: trunkFloat(geopoint.geometry.location.lat()),
        lon: trunkFloat(geopoint.geometry.location.lng())
      }
      let action
      if (this.publicationGeopoint && this.publicationGeopoint.id) {
        address.id = this.publicationGeopoint.id
        action = 'sell/editGeopoint'
      } else {
        action = 'sell/addGeopoint'
      }
      store.dispatch(action, address)
        .finally(() => { store.dispatch('sell/setIsFetching', false) })
    },

    pinToAddress (e) {
      if (e.latLng) {
        store.dispatch('sell/setIsFetching', true)
        let pin = {
          ...this.publicationGeopoint,
          lat: trunkFloat(e.latLng.lat()),
          lon: trunkFloat(e.latLng.lng())
        }
        store.dispatch('sell/editGeopoint', pin)
          .finally(() => { store.dispatch('sell/setIsFetching', false) })
      }
    },

    handleFocus () {
      const mapsAutocomplete = document.getElementById('gMapAddress')
      mapsAutocomplete && mapsAutocomplete.setAttribute('autocomplete', 'chrome-off')
      this.$emit('focus')
    }
  }
}
</script>

<style lang="scss">
  .gMapContainer {
    border-radius: 0.25rem;
    overflow: hidden;
    width: 100%;
    height: 410px;
  }

  .required-tip {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/GMapAutocompleteAddress.vue